import { useEffect, useState } from "react";
import { listCountries } from "../../api/documents";

let cache = null;

export const useCountries = () => {
  const [countries, setCountries] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    listCountries()
      .then((data) => {
        cache = data;
        setCountries(data);
      })
      .catch(() => setCountries([]));
  }, []);
  return countries;
};

export const countryRule = (countries, code) => (code ? countries.find((c) => c.code === code) || null : null);
